import { recordCalibrationEvent } from '@framework/utils/operationCalibration';
import type { ICommand } from '@model-framework/command';
import type { StickyZoneKey } from '@view-model/domain/key';
import type { DisplayOrderRepository } from '@view-model/models/framework/display-order';
import { NodeEntityOperation } from '../adapter';
import type { StickyNode } from '../domain';
import type { ViewModelEntity } from '@view-model/domain/view-model';

export class StickyNodeDisplayOrderAddToZoneCommand implements ICommand {
  constructor(
    private readonly viewModel: ViewModelEntity,
    private readonly node: StickyNode,
    private readonly nodeEntityOperation: NodeEntityOperation,
    private readonly zoneKey: StickyZoneKey,
    private readonly displayOrderRepository: DisplayOrderRepository
  ) {}

  do(replay = false): void {
    recordCalibrationEvent('node.create', { nodes: 1, replay: Number(replay), inZone: 1 });
    this.nodeEntityOperation.save(this.node);
    this.displayOrderRepository.addNode(this.node.id, this.zoneKey.id.toString()).then();
  }

  undo(): void {
    const node = NodeEntityOperation.getNode(this.node.key, this.viewModel);
    if (!node) return;
    this.nodeEntityOperation.remove(node);
    this.displayOrderRepository.removeNode(this.node.id).then();
  }

  redo(): void {
    const node = NodeEntityOperation.getNode(this.node.key, this.viewModel);
    if (node) return;
    this.do(true);
  }

  async canUndo(): Promise<boolean> {
    return !!NodeEntityOperation.getNode(this.node.key, this.viewModel);
  }

  async canRedo(): Promise<boolean> {
    return !NodeEntityOperation.getNode(this.node.key, this.viewModel);
  }
}
